module.exports = __webpack_public_path__ + "0f8579b027590922db14d388ca01b9c9.woff2";